var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Social_Icons_16px_Instagram",
    "data-name": "Social Icons \\u2013 16px / Instagram",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.7,15.952a5.9,5.9,0,0,1-1.942-.372,3.921,3.921,0,0,1-1.417-.923A3.917,3.917,0,0,1,.42,13.24,5.937,5.937,0,0,1,.048,11.3C.009,10.451,0,10.168,0,8S.009,5.549.048,4.7A5.952,5.952,0,0,1,.42,2.759a3.921,3.921,0,0,1,.923-1.417A3.921,3.921,0,0,1,2.759.42,5.952,5.952,0,0,1,4.7.048C5.549.009,5.832,0,8,0s2.451.009,3.3.048A5.937,5.937,0,0,1,13.24.42a3.917,3.917,0,0,1,1.417.923,3.921,3.921,0,0,1,.923,1.417A5.9,5.9,0,0,1,15.952,4.7c.04.841.049,1.122.049,3.3s-.009,2.458-.049,3.3a5.873,5.873,0,0,1-.372,1.941,4.086,4.086,0,0,1-2.34,2.34,5.873,5.873,0,0,1-1.941.372c-.841.04-1.122.049-3.3.049S5.542,15.991,4.7,15.952ZM4.767,1.488a4.455,4.455,0,0,0-1.486.275,2.494,2.494,0,0,0-.92.6,2.494,2.494,0,0,0-.6.92,4.455,4.455,0,0,0-.275,1.486c-.038.847-.046,1.1-.046,3.233s.008,2.385.046,3.233a4.486,4.486,0,0,0,.275,1.485,2.486,2.486,0,0,0,.6.92,2.479,2.479,0,0,0,.92.6,4.419,4.419,0,0,0,1.486.275c.84.039,1.093.047,3.233.047s2.393-.008,3.233-.047a4.4,4.4,0,0,0,1.485-.275,2.65,2.65,0,0,0,1.518-1.518,4.4,4.4,0,0,0,.275-1.485c.039-.841.047-1.094.047-3.233s-.008-2.393-.047-3.233a4.419,4.419,0,0,0-.275-1.486,2.479,2.479,0,0,0-.6-.92,2.486,2.486,0,0,0-.92-.6,4.486,4.486,0,0,0-1.485-.275c-.848-.038-1.1-.046-3.233-.046S5.614,1.45,4.767,1.488ZM3.892,8A4.108,4.108,0,1,1,8,12.108,4.113,4.113,0,0,1,3.892,8ZM5.333,8A2.667,2.667,0,1,0,8,5.333,2.669,2.669,0,0,0,5.333,8ZM11.31,3.73a.96.96,0,1,1,.96.96A.961.961,0,0,1,11.31,3.73Z",
    transform: "translate(0 0)",
    fill: "#d3d3d3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a823e6bc1e5436d274fbab5910095ca7.svg";
export { ForwardRef as ReactComponent };